import { useTranslation } from 'react-i18next'

import Seo from '../components/Seo'
import REEL from 'url:../assets/reel/oleshky-reel.mp4'

// The finished Oleshky slideshow video (1080×1350 MP4 for Instagram), to watch and download. Not linked
// from the site: open /reel. Made with scripts/oleshky-reel/.
export default function Reel() {
  const { t } = useTranslation()

  return (
    <div className='flex min-h-screen w-full flex-col items-center justify-center gap-4 bg-white py-4'>
      <Seo />
      <video
        src={REEL}
        controls
        playsInline
        className='w-[420px] max-w-full outline outline-gray-200'
      />
      <a
        href={REEL}
        download='oleshky-reel.mp4'
        className='rounded-full bg-blue-800 px-6 py-3 text-white shadow-lg transition hover:bg-blue-700'
      >
        {t('rallies.reel.download')}
      </a>
    </div>
  )
}
